import React, { useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Menu, X, Mail, Phone, Globe } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const CATS = [["all", "All"], ["technology", "Technology"], ["ai-data", "AI & Data"], ["design", "Design & Creative"], ["marketing", "Digital Marketing"], ["business", "Business & Management"], ["other", "Other Professional"]];
export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export function goSection(navigate, id) {
  if (window.location.pathname !== "/internship") { navigate(`/internship#${id}`); setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 400); return; }
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
}

function Header() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const links = [["Home", "top"], ["Explore Internships", "explore"], ["Internship Benefits", "benefits"], ["How It Works", "process"], ["FAQs", "faq"], ["Contact", "contact"]];
  const go = (id) => { setOpen(false); goSection(navigate, id); };
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-lg border-b border-border" data-testid="intern-header">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center gap-6">
        <Link to="/" data-testid="intern-logo"><img src="/viriks-logo.jpg" alt="VIRIKS" className="h-9" /></Link>
        <nav className="hidden lg:flex gap-6 text-sm font-medium text-navy/80">
          {links.map(([l, id]) => <button key={id} onClick={() => go(id)} className="hover:text-amber transition-colors" data-testid={`intern-nav-${id}`}>{l}</button>)}
        </nav>
        <div className="ml-auto flex items-center gap-3">
          <Link to={user ? "/learner/internship" : "/login"} state={user ? undefined : { from: { pathname: "/learner/internship" } }} className="hidden sm:inline text-sm font-semibold text-navy hover:text-amber" data-testid="intern-login">{user ? "My Internship" : "Student Login"}</Link>
          <button onClick={() => navigate("/internship/apply")} className="rounded-full viriks-amber text-white text-sm font-semibold px-5 py-2.5 hover:opacity-90 transition-opacity" data-testid="intern-apply-header">Apply Now</button>
          <button className="lg:hidden" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="intern-menu">{open ? <X /> : <Menu />}</button>
        </div>
      </div>
      {open && <div className="lg:hidden border-t border-border bg-white px-6 py-3 flex flex-col gap-3 text-sm">{links.map(([l, id]) => <button key={id} className="text-left" onClick={() => go(id)}>{l}</button>)}<Link to="/login">Student Login</Link></div>}
    </header>
  );
}

function Footer() {
  const col = (t, items) => (
    <div><div className="font-heading font-bold text-white mb-4">{t}</div><ul className="space-y-2 text-sm text-white/60">{items.map(([l, to]) => <li key={l}><Link to={to} className="hover:text-amber">{l}</Link></li>)}</ul></div>
  );
  return (
    <footer id="contact" className="bg-[#111111] text-white" data-testid="intern-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid sm:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-1">
          <div className="bg-white rounded-md p-1.5 w-fit"><img src="/viriks-logo.jpg" alt="VIRIKS" className="h-8" /></div>
          <p className="text-sm text-white/60 mt-4">VIRIKS — Learn. Experience. Build Your Career.</p>
        </div>
        {col("Quick Links", [["Home", "/"], ["Internship Programs", "/internship"], ["About Us", "/page/about-us"], ["Contact Us", "/page/contact-us"], ["Student Login", "/login"], ["Verify Certificate", "/verify-certificate"]])}
        {col("Internship Categories", CATS.slice(1, 6).map(([k, l]) => [l, `/internship?category=${k}#explore`]))}
        {col("Policies", [["Terms & Conditions", "/page/terms"], ["Privacy Policy", "/page/privacy-policy"], ["Refund & Cancellation Policy", "/page/refund-policy"]])}
        <div><div className="font-heading font-bold mb-4">Contact</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex gap-2"><Globe size={16} className="text-amber" /> viriks.com</li>
            <li><a href="mailto:info@viriks.in" className="flex gap-2 hover:text-amber" data-testid="intern-email"><Mail size={16} className="text-amber" /> info@viriks.in</a></li>
            <li><a href="tel:+918920208457" className="flex gap-2 hover:text-amber" data-testid="intern-phone"><Phone size={16} className="text-amber" /> 8920208457</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 text-center text-xs text-white/40 py-5">© {new Date().getFullYear()} VIRIKS. All rights reserved.</div>
    </footer>
  );
}

export default function InternshipLayout() {
  return <div id="top" className="min-h-screen bg-white"><Header /><Outlet /><Footer /></div>;
}
